import { render, staticRenderFns } from "./OfflineServices.vue?vue&type=template&id=b0a5fe36&scoped=true"
import script from "./OfflineServices.vue?vue&type=script&lang=js"
export * from "./OfflineServices.vue?vue&type=script&lang=js"
import style0 from "./OfflineServices.vue?vue&type=style&index=0&id=b0a5fe36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a5fe36",
  null
  
)

export default component.exports